export default {"src":"/_next/static/media/lgWebOS.b104e99a.svg","height":28,"width":107,"blurWidth":0,"blurHeight":0};